var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashDelete = function SvgTrashDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9V20H17.5V9H19.5V21C19.5 21.5523 19.0523 22 18.5 22H6.5C5.94772 22 5.5 21.5523 5.5 21V9H7.5ZM11.5 9V18H9.5V9H11.5ZM15.5 9V18H13.5V9H15.5ZM15.5 2C15.9304 2 16.3126 2.27543 16.4487 2.68377L17.22 4.999L20.5 5V7H4.5V5L7.779 4.999L8.55132 2.68377C8.68743 2.27543 9.06957 2 9.5 2H15.5ZM14.7792 4H10.2208L9.887 4.999H15.112L14.7792 4Z",
    fill: "#DF2020"
  })));
};
export { SvgTrashDelete as ReactComponent };
export default __webpack_public_path__ + "assets/1f3cec09.svg";